import * as React from 'react'
import { SiteFooter } from "../../footer"
import { SiteHeader } from "../../header"
import { CertificatePage } from "./CertificatePage"
import { useStyles } from "./style"

export interface CertificatePageLayoutProps {
  isCustom: boolean;
  logo: string | null;
  footer: string | null;
}

export const CertificatePageLayout: React.FC<CertificatePageLayoutProps> = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.certificatePageWrapper} >
      <div className={classes.wrapper}>
        <SiteHeader logo={props.logo} isCustom={props.isCustom}/>
        <div className={classes.container}>
          <CertificatePage />
        </div>
      </div>
      {props.footer &&
        <SiteFooter link={props.footer} className={classes.layoutFooter}/>
      }
    </div>
  )
}